import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './training.module.scss';

const PreMessageDisplay = ({ userData, handelNext }) => {
  const preMsgRef = useRef();

  return (
    <div className={styles.mdContainer} style={{ left: '-596px' }}>
      <div class="modal-dialog" role="document" style={{ top: '20%' }}>
        <div class="modal-content p-2 py-4 border text-center " style={{ minWidth: '1100px' }}>
          {userData?.application_pre_message && (
            <>
              <div
                key="preMsg"
                // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                dangerouslySetInnerHTML={{ __html: eval('`' + userData?.application_pre_message + '`') }}
              />
              <div style={{ display: 'none' }}>
                <div
                  ref={preMsgRef}
                  key="preMsg"
                  // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                  dangerouslySetInnerHTML={{ __html: eval('`' + userData?.application_pre_message + '`') }}
                />
              </div>
            </>
          )}
          {!userData?.application_pre_message || userData?.application_pre_message === '<p><br></p>'
            && <FormattedMessage
                  id="adp.pre.msg"
                  defaultMessage="There are different categories of permits.
                  Please understand which category you should apply for before proceeding." />
          }
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-primary mt-4 w-25"
              onClick={() => { handelNext('language', 'language'); }}
            >
              <FormattedMessage id="inspections.new.next" defaultMessage="Next" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreMessageDisplay;
